import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SitesService } from '@shared/services/sites.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class QualityControlGuard implements CanActivate {
    constructor(private siteService: SitesService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.siteService.hasAnyQualityControlSites();
    }
}